import { getErrorMessage } from '../error-handler';
import { CustomRequestResponse } from './custom-request';

export const parseErrorResponse = async (
  response: Response,
): Promise<CustomRequestResponse> => {
  try {
    const json = await response.json();
    return {
      status: response.status,
      message: getErrorMessage(json),
      errors: json.errors,
      response: json,
    };
  } catch {
    // The eslint warning has been disabled to conform with the original request.js
    // eslint-disable-next-line no-throw-literal
    throw {
      status: response.status,
      message: response.statusText || `Error ${response.status}`,//TODO: show message base on status code if message is empty
    };
  }
};
